import {getStatusValue} from '../../helpers';
import React from 'react';
import moment from 'moment';

export function columns () {
  return [{
    id: 1, title: 'UUID', field: 'uuid', filter: '', filterMinWidth: 120, filterLabel: 'Filter By UUID'
  }, {
    id: 2, title: 'Label', field: 'label', filter: '', filterMinWidth: 110, filterLabel: 'Filter By Label'
  }, {
    id: 3, title: 'Camera UUID', field: 'pcam_uuid', filter: '', filterMinWidth: 165, filterLabel: 'Filter By Camera UUID'
  }, {
    id: 4, title: 'Type', field: 'type', filter: '', filterMinWidth: 100, filterLabel: 'Filter By Type'
  }, {
    id: 5, title: 'EWC', field: 'ewc_instance_name', filter: '', filterMinWidth: 160, filterLabel: 'Filter By EWC Name'
  }, {
    id: 6, title: 'Status/Last Heartbeat', field: 'status', filter: 'all', filterType: 'select', filterMinWidth: 140,
    getValue: rowData => getStatusAndHeartbeat(rowData.status, rowData.heartbeat),
    options: [{ label: 'All', value: 'all' }, { label: 'OK', value: 'OK' }, { label: 'NOK', value: 'NOK' }, { label: 'OFFLINE', value: 'OFFLINE' }, { label: 'UNKNOWN', value: 'UNKNOWN' }]
  }, {
    id: 7, title: 'PP Status', field: 'pp_status', filter: 'all', filterType: 'select', filterMinWidth: 100,
    getValue: rowData => getPPStatus(rowData.pp_status),
    options: [{ label: 'All', value: 'all' }, { label: 'OK', value: 'OK' }, { label: 'NOK', value: 'NOK' }, { label: 'OFFLINE', value: 'OFFLINE' }, { label: 'UNKNOWN', value: 'UNKNOWN' }],
  }];
}

function getStatusAndHeartbeat(status, heartbeat) {
  let date = heartbeat !== undefined && heartbeat !== null && heartbeat !== ''
    ? moment(heartbeat).format('YYYY-MM-DD HH:mm') :
    '-';
  return (
    <div>
      {getStatusValue(status, getColor(status))}
      <div style={{paddingLeft: '1.5rem'}}>
        {date}
      </div>
    </div>
  );
}

function getPPStatus(ppStatus) {
  return ppStatus ? getStatusValue(ppStatus, getColor(ppStatus)) : '';
}

function getColor(status) {
  return {color: status === 'OK' ? 'green' : status === 'NOK' ? 'red' : 'gray'};
}
